import { AnalyticsService } from './analytics.service';
import { AnalyticsEvent } from '../../models/analytics/analytics-event.model';
import { Injector } from '@angular/core';

interface ComponentWithAnalytics {
  injector?: Injector;
  analyticsService?: AnalyticsService;
}

// Make sure eventType is required in the return type
type EventConfigFunction = (
  this: ComponentWithAnalytics,
  ...args: any[]
) => Pick<AnalyticsEvent, 'eventType'> &
  Partial<Omit<AnalyticsEvent, 'eventType'>>;

export function TrackEvent(
  eventConfig:
    | (Pick<AnalyticsEvent, 'eventType'> &
        Partial<Omit<AnalyticsEvent, 'eventType'>>)
    | EventConfigFunction
) {
  return function (
    target: any,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ) {
    const originalMethod = descriptor.value;

    descriptor.value = function (this: ComponentWithAnalytics, ...args: any[]) {
      let analyticsService: AnalyticsService | null = null;

      try {
        if (this.injector) {
          analyticsService = this.injector.get(AnalyticsService);
        } else if (this.analyticsService) {
          analyticsService = this.analyticsService;
        }
      } catch (error) {
        console.warn('AnalyticsService not available:', error);
      }

      if (analyticsService) {
        try {
          const eventData =
            typeof eventConfig === 'function'
              ? eventConfig.apply(this, args)
              : eventConfig;

          if (!eventData.eventType) {
            throw new Error('eventType is required for analytics events');
          }

          analyticsService.trackEvent(eventData);
        } catch (error) {
          console.warn('Error tracking analytics event:', error);
        }
      }

      return originalMethod.apply(this, args);
    };

    return descriptor;
  };
}
